<app-page-wrapper [title]="'cabinet' | i18n" [navActionInlineOnMobile]="true">
  <ng-container title-extra>
    <div
      class="tw-relative tw-flex tw-flex-wrap tw-items-center tw-gap-2.5 sm:tw-w-full sm:tw-flex-nowrap"
    >
      @if (pillsOffset() > 0) {
        <button
          type="button"
          class="tw-hidden tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-dt-custom-teal-11 tw-bg-dt-custom-teal-3 tw-cursor-pointer sm:tw-absolute sm:tw-left-2 sm:tw-top-1/2 sm:-tw-translate-y-1/2 sm:tw-z-10 sm:tw-flex"
          [attr.aria-label]="'previous' | i18n"
          (click)="shiftPills(-1)"
        >
          <icon
            name="right-arrow"
            [size]="5"
            [currentColor]="'dt-custom-teal-11'"
            [disableArrowOverride]="true"
            class="tw-rotate-180"
          ></icon>
        </button>
      }
      <ng-container
        *ngTemplateOutlet="
          metricPill;
          context: {
            label: 'totalFiles' | i18n,
            value: table.summary().total,
            valueClass: 'tw-text-dt-text-headings',
            hidden: !isPillVisible(0),
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          metricPill;
          context: {
            label: 'pdf' | i18n,
            value: table.summary().pdf,
            valueClass: 'tw-text-dt-error-500',
            hidden: !isPillVisible(1),
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          metricPill;
          context: {
            label: 'images' | i18n,
            value: table.summary().jpg,
            valueClass: 'tw-text-dt-information-500',
            hidden: !isPillVisible(2),
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          metricPill;
          context: {
            label: 'csv' | i18n,
            value: table.summary().csv,
            valueClass: 'tw-text-dt-success-500',
            hidden: !isPillVisible(3),
          }
        "
      ></ng-container>
      @if (pillsOffset() < maxPillsOffset) {
        <button
          type="button"
          class="tw-hidden tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-dt-custom-teal-11 tw-bg-dt-custom-teal-3 tw-cursor-pointer sm:tw-absolute sm:tw-right-2 sm:tw-top-1/2 sm:-tw-translate-y-1/2 sm:tw-z-10 sm:tw-flex"
          [attr.aria-label]="'next' | i18n"
          (click)="shiftPills(1)"
        >
          <icon
            name="right-arrow"
            [size]="5"
            [currentColor]="'dt-custom-teal-11'"
            [disableArrowOverride]="true"
          ></icon>
        </button>
      }
    </div>
  </ng-container>

  <ng-container nav-action>
    <app-gloss-button
      class="sm:tw-hidden"
      [options]="uploadNewFileOptions"
      [fontClass]="'tw-text-white tw-flex-row-reverse'"
    ></app-gloss-button>
    <app-gloss-button
      class="tw-hidden sm:tw-block sm:tw-shrink-0"
      [options]="{
        text: '',
        fullClass:
          'tw-shadow-manage-accounts tw-flex tw-h-11 tw-w-16 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-custom-teal-11',
        isEnabled: true,
        icon: 'upload-file',
        iconClass: 'tw-h-4 tw-w-4 tw-text-white',
        onClick: uploadNewFile.bind(this),
      }"
      [fontClass]="'tw-text-white'"
    ></app-gloss-button>
  </ng-container>

  <div
    class="tw-grid tw-w-full tw-grid-cols-[2fr_3fr] tw-items-start tw-gap-4 lg:tw-flex lg:tw-flex-col lg:tw-items-stretch"
  >
    <div
      class="tw-flex tw-min-w-0 tw-flex-col tw-gap-3 tw-overflow-hidden tw-px-4 gutter-bleed-column tw-py-2"
    >
      <p class="tw-m-0 tw-text-xs tw-uppercase tw-tracking-[0.03em] tw-text-dt-text-tertiary">
        {{ "files" | i18n }}
      </p>
      @if (table.data()?.length) {
        <div class="tw-flex tw-flex-col tw-gap-3">
          @for (row of table.data(); track row.fileAndAccount.file.id) {
            <div
              role="button"
              tabindex="0"
              class="tw-box-border tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-2xl tw-bg-color-surface-card tw-px-4 tw-py-3 tw-text-left tw-transition-colors"
              [ngClass]="{
                'tw-shadow-elevation-card': table.selectedFile()?.id !== row.fileAndAccount.file.id,
                'card-selected': table.selectedFile()?.id === row.fileAndAccount.file.id,
              }"
              (click)="table.onRowClicked(row.fileAndAccount.file)"
              (keydown.enter)="table.onRowClicked(row.fileAndAccount.file)"
              (keydown.space)="table.onRowClicked(row.fileAndAccount.file); $event.preventDefault()"
            >
              <div
                class="card-selected-tile tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-shadow-icon-shadow"
                [ngClass]="row.iconMeta.badgeClass"
              >
                <icon
                  [name]="row.iconMeta.icon"
                  [size]="5"
                  [currentColor]="row.iconMeta.iconColor"
                ></icon>
              </div>
              <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-1">
                <span
                  class="card-selected-name tw-truncate tw-text-sm tw-font-semibold tw-text-color-text-default"
                >
                  {{ row.fileAndAccount.file.name }}
                </span>
                <span class="tw-truncate tw-text-xs tw-text-color-text-secondary">
                  {{ row.linkedAccountNames || ("noLinkedAccount" | i18n) }}
                </span>
              </div>
              @if (row.statementPeriod.fromDate) {
                <div class="tw-flex tw-shrink-0 tw-flex-col tw-items-end tw-gap-1 tw-text-right">
                  <span class="tw-text-xs tw-text-color-text-default">
                    {{ row.statementPeriod.fromDate | date: "MMM d" }}
                  </span>
                  <span class="tw-text-[11px] tw-text-color-text-tertiary">
                    {{ row.statementPeriod.toDate | date: "MMM d, y" }}
                  </span>
                </div>
              } @else {
                <span class="tw-shrink-0 tw-text-xs tw-text-color-text-tertiary">&mdash;</span>
              }
              <icon name="right-arrow" [size]="4" class="tw-shrink-0"></icon>
            </div>
          }
        </div>
      } @else {
        <app-empty-state titleKey="noFiles" descriptionKey="noFilesDescription" />
      }
    </div>

    @if (table.selectedFile()) {
      <div
        appGlossScroll
        class="tw-sticky tw-top-4 tw-min-w-0 tw-self-start tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-white tw-shadow-card-elevated dark:tw-border-transparent lg:tw-fixed lg:tw-left-0 lg:tw-top-0 lg:tw-bottom-0 lg:tw-w-full lg:tw-z-50 lg:tw-overflow-auto lg:tw-bg-color-surface-page lg:tw-rounded-none lg:tw-border-none lg:tw-pb-[var(--app-menu-height,0px)]"
      >
        <app-cabinet-details
          [selectedFile]="table.selectedFile()"
          (fileDeleted)="table.clearSelection()"
          (onBackClicked)="closeCabinetDetails()"
        ></app-cabinet-details>
      </div>
    } @else if (!deviceDetectorService.isMobile()) {
      <div
        class="tw-flex tw-min-w-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-border tw-border-white tw-shadow-card-elevated lg:tw-hidden"
      >
        <app-empty-state titleKey="selectAFile" descriptionKey="selectAFileDescription" />
      </div>
    }
  </div>
</app-page-wrapper>

<!-- Upload Dialog Overlay - Outside page wrapper for full-screen modal -->
@if (showUploadDialog) {
  <div
    class="cabinet-upload-overlay"
    [appScrollLock]="showUploadDialog"
    (wheel)="$event.stopPropagation()"
  >
    <div class="cabinet-upload-container">
      <app-cabinet-file-upload
        [showComponent]="showUploadDialog"
        (closed)="closeUploadForm($event)"
        (formStepChanged)="handleFormStepChange($event)"
      ></app-cabinet-file-upload>
    </div>
  </div>
}

<ng-template
  #metricPill
  let-label="label"
  let-value="value"
  let-valueClass="valueClass"
  let-hidden="hidden"
>
  <div
    class="tw-flex tw-min-w-[90px] tw-flex-col tw-items-center tw-text-center tw-px-4 tw-py-3 sm:tw-px-1 sm:tw-py-2 tw-rounded-xl tw-bg-dt-surface-input tw-shadow-card-elevated sm:tw-min-w-0 sm:tw-flex-1"
    [ngClass]="{ 'sm:tw-hidden': hidden }"
  >
    <span
      class="tw-text-lg sm:tw-text-sm tw-font-semibold tw-whitespace-nowrap"
      [ngClass]="valueClass"
    >
      {{ value }}
    </span>
    <span
      class="tw-text-xs tw-uppercase tw-text-dt-text-secondary tw-whitespace-nowrap sm:tw-whitespace-normal sm:tw-text-[9px] sm:tw-leading-tight"
    >
      {{ label }}
    </span>
  </div>
</ng-template>
